import { Card, CardBody, Table } from "reactstrap";
import { Spinner } from "AbstractElements";
import Moment from "moment";
import "moment/locale/id";
import PaginationComponent from "Component/Learning/Common/Pagination";

const truncate = (value, max = 48) => {
	const text = String(value ?? "").trim();
	if (!text) return "-";
	if (text.length <= max) return text;
	return `${text.slice(0, max)}…`;
};

const formatAverage = (value) => {
	if (value == null || Number.isNaN(value)) return "-";
	return Number(value).toFixed(1);
};

const SessionsTable = ({
	sessions,
	pagination,
	isLoading,
	hasDateFilter = false,
	onRowClick,
	onPageChange,
}) => {
	const handleBackPagination = () => {
		if (!pagination || pagination.current_page <= 1) return;
		onPageChange(pagination.current_page - 1);
	};

	const handleNextPagination = () => {
		if (!pagination || pagination.current_page >= pagination.last_page) return;
		onPageChange(pagination.current_page + 1);
	};

	const handleClickPagination = (page) => {
		onPageChange(Number(page));
	};

	return (
		<div>
			<div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-2 mb-3">
				<div>
					<h5 className="mb-1 fw-semibold">Daftar Sesi</h5>
					<small className="text-muted">
						Klik baris untuk melihat detail jawaban progress.
						{hasDateFilter
							? " Daftar difilter berdasarkan tanggal checkout."
							: ""}
					</small>
				</div>
			</div>

			<Card className="border-0 rounded-4" style={{ boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)" }}>
				<CardBody className="p-0">
					{isLoading ? (
						<div className="loader-box py-5">
							<Spinner attrSpinner={{ className: "loader-30" }} />
						</div>
					) : sessions.length === 0 ? (
						<div className="text-center text-muted py-5 px-3">
							{hasDateFilter
								? "Tidak ada sesi pada periode yang dipilih."
								: "Belum ada data private session progress."}
						</div>
					) : (
						<div className="table-responsive">
							<Table hover className="mb-0 align-middle">
								<thead className="table-light">
									<tr>
										<th style={{ width: 56 }}>#</th>
										<th>Tentor</th>
										<th>Siswa / Member</th>
										<th>Checkout</th>
										<th>Rata-rata</th>
										<th>Catatan</th>
									</tr>
								</thead>
								<tbody>
									{sessions.map((row, index) => {
										const rowNumber = pagination?.from
											? pagination.from + index
											: index + 1;

										return (
											<tr
												key={row.id ?? `${row.tentorName}-${index}`}
												onClick={() => onRowClick(row)}
												style={{ cursor: "pointer" }}
											>
												<td>{rowNumber}</td>
												<td className="fw-semibold">{row.tentorName}</td>
												<td>{row.memberName}</td>
												<td>
													{row.checkoutAt
														? Moment(row.checkoutAt)
																.locale("id")
																.format("DD MMM YYYY HH:mm")
														: "-"}
												</td>
												<td>{formatAverage(row.averageScore)}</td>
												<td>{truncate(row.note)}</td>
											</tr>
										);
									})}
								</tbody>
							</Table>
						</div>
					)}
				</CardBody>
			</Card>

			{pagination && pagination.last_page > 1 && (
				<div className="mt-3">
					<PaginationComponent
						pagination={pagination}
						handleBackPagination={handleBackPagination}
						handleClickPagination={handleClickPagination}
						handleNextPagination={handleNextPagination}
					/>
				</div>
			)}
		</div>
	);
};

export default SessionsTable;
